import React, { useId } from 'react'
import type { ConnectionResult } from '../../services/apiClient'
import ConnectionOverview from './ConnectionOverview'
import ConnectionPathCard from './ConnectionPathCard'
import { summarize } from './connectionSummary'

/**
 * One search result: the overview (a direct link or the companies both
 * share), then longer chains. `past` labels it as former roles.
 */
const ConnectionResults: React.FC<{ result: ConnectionResult; past?: boolean }> = ({
  result,
  past = false,
}) => {
  const headingId = useId()
  const summary = summarize(result)
  const ends = result.paths[0]?.nodes
  const hasOverview = !!summary.direct || summary.shared.length > 0
  if (!ends) return null
  const count = summary.longer.length
  return (
    <>
      {hasOverview && (
        <ConnectionOverview
          summary={summary}
          from={ends[0]}
          to={ends[ends.length - 1]}
          eyebrow={past ? 'Tidligere forbindelse' : 'Direkte forbindelse'}
        />
      )}
      {count > 0 && (
        <section className={hasOverview ? 'mt-7' : ''} aria-labelledby={headingId}>
          <h3 id={headingId} className="text-[15px] font-bold text-ink">
            {hasOverview
              ? 'Gennem andre selskaber'
              : `${count} ${past ? (count === 1 ? 'tidligere forbindelse' : 'tidligere forbindelser') : count === 1 ? 'forbindelse' : 'forbindelser'} fundet`}
          </h3>
          <div className="mt-3 space-y-3">
            {summary.longer.map((p, i) => (
              <ConnectionPathCard
                key={p.nodes.map((n) => n.id).join('>')}
                path={p}
                title={hasOverview ? `Vej ${i + 1}` : i === 0 ? 'Korteste vej' : `Alternativ ${i}`}
              />
            ))}
          </div>
        </section>
      )}
    </>
  )
}

export default ConnectionResults
